import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { VariantSingleCreateSubmit } from "services/apiService";
import toast from "react-hot-toast";

const VariantCreate = ({ open, onClose, onSuccess }: any) => {
  const [variantName, setVariantName] = useState("");
  const [variantSlug, setVariantSlug] = useState("");

  const handleVariantChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.value;
    setVariantName(name);
    setVariantSlug(name.toLowerCase().replace(/\s+/g, "-"));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        name: variantName,
        slug: variantSlug,
        image_path: null,
        is_active: 1,
      };
      const response = await VariantSingleCreateSubmit(payload);
      if (response.status_code === 200) {
        toast.success("Variant created successfully");
        onClose();
        onSuccess();
      }
    } catch (error) {
      toast.error("Failed to create Variant");
    }
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="h6"
          className="text-center mb-4"
          style={{
            fontWeight: "bold",
            textTransform: "uppercase",
            backgroundColor: "#007bff",
            padding: "2px",
            color: "white",
          }}
        >
          Create Variant
        </Typography>
        <TextField
          fullWidth
          label="Variant Name"
          variant="outlined"
          value={variantName}
          onChange={handleVariantChange}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Variant Slug"
          variant="outlined"
          value={variantSlug}
          disabled
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!variantName}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default VariantCreate;
